export default "__VITE_ASSET__CLNl_Cec__"